export const CommonConstant = {
  idleTime: 20 * 60, // x minutes
  redirectUrlInternalUser: "https://support.dnb.com/?CUST=Internal&Origin=DIVR" // Submit case redirect url for Internal users
}
